<template>
    <div style="position: fixed;left:0px;right: 0px;top:0px;bottom: 0px;overflow: hidden">
        <header ref="header" style="margin-top:40px">
            <mt-search v-model="searchName" ></mt-search>
        </header>
        <ul
                v-infinite-scroll="loadMore"
                :style="{'height':curHeight,'width':'100%','margin':'0px','padding':'0px 0px 85px 0px','overflow': 'auto'}"
                infinite-scroll-disabled="loading"
                infinite-scroll-distance="5">
            <li v-for="item in overseaApplicationList" style="border-bottom:1px solid #e4e4e44f;padding:3px 0px">
                <div class="list_card">
                    <div class="first_text" style="padding:0.18rem 0rem;border-bottom: 1px solid #dadada;color: black;">
                        <p style="font-weight: bold">保單號碼</p>
                        <p style="text-align: right">{{item.policyNo}}</p>
                    </div>
                    <div style="color:#969696" id="content_text">
                        <div>
                            <p>介紹人姓名</p><p>{{item.partnerName}}</p>
                        </div>
                        <div>
                            <p>日期</p><p>{{getDate(item.mcvDate)}}</p>
                        </div>
                        <div>
                            <p>中文姓名</p><p>{{item.insuredNameChi}}</p>
                        </div>
                        <div>
                            <p>英文姓名</p><p>{{item.insuredNameEng}}</p>
                        </div>
                        <div>
                            <p>保險公司</p><p>{{item.insuranceName}}</p>
                        </div>
                        <div>
                            <p>投保額</p><p>{{item.sumInsured}}</p>
                        </div>
                        <div>
                            <p>狀態</p><p>{{getStatus(item.status)}}</p>
                        </div>
                        <div>
                            <p>產品名稱</p><p>{{item.productName}}</p>
                        </div>
                        <div>
                            <p>繳款模式</p><p>{{getPayTerm(item.payTerm)}}</p>
                        </div>
                    </div>
                </div>
            </li>
            <li style="text-align: center"><i v-if="loading" class="fa fa-spinner fa-pulse fa-2x fa-fw"></i></li>
            <li style="text-align: center" class="dev-line" v-if="overseaApplicationList.length==pager.total&&pager.total!=0" ><span style="background:#f4f4f4">我已经到底了</span></li>
        </ul>

        <mt-button type="primary" size="large" style="position: fixed;bottom: 0px;" @click="goApplication()">预约</mt-button>
    </div>
</template>
<script>
    import axios from 'axios'
    import {queryPolicyList,queryOverseaApplicationList,insertPolicy,queryPolicyById,queryStaffByStaffType,queryRemarkOption,
        updatePolicy,queryInsuranceOption,queryProductOption,queryProductPeriodOption,queryCurrencyOption,queryCustomerOption,queryFileSubTypeOption,
        policyFileUpload,initialPolicyUploadFileList,delFileById,queryOneUploadFileById,queryListBySourceIdAndType,updateUploadFile,queryOptionMyPolicy,
        queryTrOption,queryTr2Option,queryServiceOption,imageUrl,validPolicyPwd,queryMyUserPolicyList}
        from '../../api/api'

    export default {
        data(){
            return{
                curHeight:'',
                value:'',
                loading:false,
                list:[1,2,3],
                searchName:'',
                searchInsuranceId:'',
                searchStatus:'',
                searchCustName:'',
                searchPartner:'',
                searchSubmitDate:'',
                searchPayTerm:'',
                searchIsAutoPay:'',
                searchProductName:'',
                searchGroup:'',
                searchTrId:'',
                searchTr2Id:'',
                searchServiceId:'',
                moreSearch:false,
                policyList:[],
                policyTableloading:false,
                policyFormloading:false,
                pager:{
                    page:1,
                    size:2,
                    total:0
                },
                dialogName:'',
                policyFromVisible:false,
                policyRules: {
                    submitDate: [
                        {required: true, message: "請選擇投保日期", trigger: 'change' },
                    ],
                    insuranceId: [
                        {required: true, message: "請選擇保險公司", trigger: 'change' },
                    ],
                    payTerm: [
                        {required: true, message: "請選擇繳費模式", trigger: 'change' },
                    ],
                    currencyId: [
                        {required: true, message: "請選擇貨幣", trigger: 'change' },
                    ],
                    productId: [
                        {required: true, message: "請選擇主計劃", trigger: 'change' },
                    ],
                    periodId: [
                        {required: true, message: "請選擇主計劃年期", trigger: 'change' },
                    ],
                },
                policy:{
                    id:"",rev:"",policyNo:"",insuranceId:"",productId:"",periodId:"",partnerId:"",trId:"",tr2Id:"",serviceId:"",
                    submitDate:"",payTerm:"",currencyId:"",sumInsured:"",subPremium:"",recPremium:"",appPremium:"",policyDate:"",
                    premiumDate:"",coolingOffDate:"",status:0,policyStatus:1,isComm:0,isAutoPay:0,nextPremiumDate:"",levy:"",
                    nextPremium:"",remark:""
                },
                staffList:[],
                policyStaffloading:false,
                insuranceOption:[],
                productOption:[],
                productPeriodOption:[],
                currencyOption:[],
                serviceOption:[],
                tr2Option:[],
                trOption:[],
                partnerOption:[],
                customerList:[],
                policyCust:{id:"",policyId:"",clientId:"",insured:"",applicant:"",beneficiary:"",customerOption:[],index:0},
                payTermOption:[
                    //繳費方式, 1:年繳, 2:半年繳, 3:季繳, 4:月繳, 5:一次性付清
                    {label:'年繳',value:1},{label:'半年繳',value:2},{label:'季繳',value:3},{label:'月繳',value:4},{label:'一次性付清',value:5}
                ],
                statusOption:[
                    //狀態, 0:處理中, 1:存檔, 2: 終止申請, 3. 冷靜期退保, 4: 生效, 5:轉出保單, 6: 保單失效
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7},
                    {label:'拒保',value:8},{label:'廢除',value:9},{label:'不完整',value:10},{label:"退保",value:11},
                    {label:'不接受',value:12},{label:'其他',value:13},{label:'撤銷',value:14},{label:'基本保費繳足和附加契約生效',value:15},
                    {label:'未處理初始保費',value:16},{label:'已終止-主要索賠',value:18},
                    {label:'由於死亡, 保費被免除',value:19},{label:'由於殘廢，保費被免除',value:20},
                    {label:'首期保費未曾生效/退回 (例如冷靜期退保，保單撤回)',value:21}
                ],
                searchStatusOption:[
                    {label:'處理中',value:0},{label:'存檔',value:1},{label:'終止申請',value:2},{label:'冷靜期退保',value:3},
                    {label:'生效',value:4},{label:'轉出保單',value:5},{label:'保單失效',value:6},{label:'擱置',value:7},
                    {label:'拒保',value:8},{label:'廢除',value:9},{label:'不完整',value:10},{label:"退保",value:11},
                    {label:'不接受',value:12},{label:'其他',value:13},{label:'撤銷',value:14},{label:'基本保費繳足和附加契約生效',value:15},
                    {label:'未處理初始保費',value:16},{label:'已終止-主要索賠',value:18},
                    {label:'由於死亡, 保費被免除',value:19},{label:'由於殘廢，保費被免除',value:20},
                    {label:'首期保費未曾生效/退回 (例如冷靜期退保，保單撤回)',value:21},
                    {label:'處理中有跟進事項',value:-1},{label:'保單服務跟進事項',value:-2}
                ],
                policyStatusOption:[
                    //狀態2 : 0: 預先核保, 1: 正常, 2:正行使保費假期, 3:轉入保單, 4: 期滿
                    {label:'預先核保',value:0},{label:'正常',value:1},{label:'正行使保費假期',value:2},{label:'轉入保單',value:3},
                    {label:'期滿',value:4}
                ],
                listShow:false,
                currentCustomerIndex:"",
                delPolicyCustList:[],
                policyRiderList:[],
                policyRider:{id:"",policyId:"",productId:"",productPeriodId:"",premium:"",sumInsured:"",productOption:[],productPeriodOption:[],index:0},
                currencyPolicyRiderIndex:"",
                currencyPolicyRemarkIndex:"",
                delPolicyRiderList:[],
                policyRemarkList:[],
                policyRemark:{id:"",policyId:"",content:"",solvedDate:"",deadLine:"",createDate:"",index:0},
                policyRemarkOption:[],
                delPolicyRemarkList:[],
                expandPolicyRow:[],

                //file upload
                fileListView:false,
                fileList:[],
                fileUploadView:false,
                uploadFile:{id:"",fileUrl:"",fileName:"",sourceId:"",sourceType:"",sourceSubType:"",description:"",relativePath:"",file:[]},
                //end file upload
                fileSubTypeOption:[],
                uploadFileList:[],
                fileUploadLoading:false,
                policyId:"",
                sourceType:"",
                fileApp:1,
                filePen:2,
                filePol:3,
                filePos:4,
                appFileList:[],
                penFileList:[],
                polFileList:[],
                posFileList:[],
                fileLoading:false,
                appPager:{
                    page:1,
                    size:10,
                    total:0
                },
                penPager:{
                    page:1,
                    size:10,
                    total:0
                },
                polPager:{
                    page:1,
                    size:10,
                    total:0
                },
                posPager:{
                    page:1,
                    size:10,
                    total:0
                },

                reverse: false,
                activities: [],
                activeNames: [],
                productList:[],
                ownerName:"",
                count:0,
                overseaApplicationList:[]
            }
        },
        methods:{
            queryOverseaApplicationList(){
                this.listShow=true
                var params={page:this.pager.page,size:this.pager.size,searchName:this.searchName};
                    params.staffId = this.$store.getters.staff.id;
                return queryOverseaApplicationList(params).then(res=>{
                    if(res.errcode==200){
                        this.loading=false
                        let {size,page,total,data:overseaApplicationList=[]}=res.data;
                        this.overseaApplicationList=overseaApplicationList;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        if(this.type==2&&this.pager.total>0){
                            if(null==this.overseaApplicationList||this.overseaApplicationList.length==0){
                                this.pager.page=1;
                                this.queryOverseaApplicationList();
                            }
                        }

                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            toDetail(uuid){
                this.$router.push('/mobile/policyDetail?uuid='+uuid)
            },
            indexMethod(index){
                index = index +1;
                if(this.pager.page>1){
                    return (this.pager.size * (this.pager.page-1)) + index;
                }
                return index;
            },
            goAnchor(selector) {
                document.querySelector(selector).scrollIntoView(true);
            },
            queryServiceOption(){
                return queryServiceOption(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:serviceOption=[]}=res;
                        this.serviceOption=serviceOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryServiceOption Error");
                });
            },
            queryTr2Option(){
                return queryTr2Option(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:tr2Option=[]}=res;
                        this.tr2Option=tr2Option;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryTr2Option Error");
                });
            },
            queryTrOption(){
                return queryTrOption(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:trOption=[]}=res;
                        this.trOption=trOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryTrOption Error");
                });
            },
            getPayTerm(value){
                if(value!=''&&value!=null&&value!=undefined){
                    return this.payTermOption.find(v=>v.value==value).label;
                }
            },
            queryOptionMyPolicy(){
                return queryOptionMyPolicy(this.$store.getters.staff.id).then(res=>{
                    if(res.errcode==200){
                        let {data:partnerOption=[]}=res;
                        this.partnerOption=partnerOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryOptionMyPolicy Error");
                });
            },
            getCurrency(val){
                return this.currencyOption.find(v=>v.id==val).name;
            },
            getPayterm(val){
                return this.payTermOption.find(v=>v.value==val).label;
            },
            getInsurance(val){
                return this.insuranceOption.find(v=>v.id==val).nameDisplay;
            },
            //file upload
            fileDownload(val){
                if(this.$store.getters.staff.isPdfPreview){
                    let dataType = val.relativePath.substring(val.relativePath.lastIndexOf(".")+1,val.relativePath.length);
                    if(dataType=="pdf"){
                        window.open("/#/attachmentView?path="+val.relativePath, 'Preview',
                            'width=800,height=800,location=no');
                    }else if(dataType=='png'||dataType=='jpg'||dataType=='jpeg'||dataType=='bmp'||dataType=='jpe'||dataType=='dib'){
                        window.open("/#/picView?path="+val.relativePath, 'Preview',
                            'width=800,height=800,location=no');
                    }else{
                        this.$message.error("文件沒法打開, 請聯絡行政人員");
                    }
                }else{
                    window.location.href=axios.defaults.baseURL+'/file/download/?id='+val.id;
                }
            },

            changeFileType(tab, event) {
                if(tab.label==='APP'){
                    this.sourceType=this.fileApp;
                }else if(tab.label==='PEN'){
                    this.sourceType=this.filePen;
                }else if(tab.label==='POL'){
                    this.sourceType=this.filePol;
                }else if(tab.label==='POS'){
                    this.sourceType=this.filePos;
                }
            },
            queryListBySourceIdAndType(){
                let params={page:"",size:"",sourceId:this.policyId,sourceType:this.sourceType};
                switch (this.sourceType) {
                    case this.fileApp:
                        params.page=this.appPager.page;params.size=this.appPager.size;
                        break;
                    case this.filePen:
                        params.page=this.penPager.page;params.size=this.penPager.size;
                        break;
                    case this.filePol:
                        params.page=this.polPager.page;params.size=this.polPager.size;
                        break;
                    case this.filePos:
                        params.page=this.posPager.page;params.size=this.posPager.size;
                        break;
                }
                this.fileLoading=true;
                return queryListBySourceIdAndType(params).then(res=>{
                    if(res.errcode==200){
                        let {size,page,total,data:fileList=[]}=res.data;
                        switch (params.sourceType) {
                            case this.fileApp:
                                this.appFileList = fileList;this.appPager.total=total;this.appPager.page=page;
                                this.appPager.size=size;
                                break;
                            case this.filePen:
                                this.penFileList = fileList;this.penPager.total=total;this.penPager.page=page;
                                this.penPager.size=size;
                                break;
                            case this.filePol:
                                this.polFileList = fileList;this.polPager.total=total;this.polPager.page=page;
                                this.polPager.size=size;
                                break;
                            case this.filePos:
                                this.posFileList = fileList;this.posPager.total=total;this.posPager.page=page;
                                this.posPager.size=size;
                                break;
                        }
                        this.fileLoading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            getFileSubType(val){
                if(val!=null&&val!=undefined&&val!=''){
                    return this.fileSubTypeOption.find(v=>v.id==val).label;
                }
                return "";
            },
            reUploadFileIndex(){
                this.fileList.forEach((v,i)=>{
                    v.index=i;
                })
            },
            removeUploadFileList(row){
                this.fileList.splice(row.index,1);
                this.reUploadFileIndex();
            },
            queryFileSubTypeOption(val){
                return queryFileSubTypeOption(val).then(res=>{
                    if(res.errcode==200){
                        let {data:fileSubTypeOption=[]}=res;
                        this.fileSubTypeOption=fileSubTypeOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryFileSubTypeOption Error");
                });
            },
            initalUploadFile(){
                this.uploadFile={id:0,fileUrl:null,fileName:"",sourceId:this.policyId,sourceType:this.sourceType,
                    sourceSubType:"",description:"",relativePath:null,file:[],index:this.fileList.length};
            },
            handleFileList(row){
                this.fileListView=true;
                this.policyId = row.id;
                this.sourceType = this.fileApp;
                this.appFileList=[];this.penFileList=[];this.polFileList=[];this.posFileList=[];
                let params={page:0,size:10,sourceId:this.policyId};
                initialPolicyUploadFileList(params).then(res=>{
                    if(res.errcode==200){
                        let {data:list=[]}=res;
                        if(list.length>0){
                            list.forEach((v,i)=>{
                                switch (v.sourceType) {
                                    case this.fileApp:
                                        this.appFileList.push(v);
                                        break;
                                    case this.filePen:
                                        this.penFileList.push(v);
                                        break;
                                    case this.filePol:
                                        this.polFileList.push(v);
                                        break;
                                    case this.filePos:
                                        this.posFileList.push(v);
                                        break;
                                }
                            })
                            this.appPager.total = list[0].totalList[0];
                            this.penPager.total = list[0].totalList[1];
                            this.polPager.total = list[0].totalList[2];
                            this.posPager.total = list[0].totalList[3];
                        }

                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("initialPolicyUploadFileList Error");
                });
            },
            //file upload
            remarkCol(row){
                if(row.status==0){
                    return {"color":"red"};
                }
            },
            pendingRow(row){
                if(row.row.policyRemarkList.length>0 && row.row.status==0){
                    return '';
                    //{ "background-color": "#f36262" }
                }else{
                    return '';
                }
            },
            getDate2(value){
                if(value!=''&&value!=null&&value!=undefined){
                    let d=new Date(value);
                    let m=d.getMonth()+1;
                    return d.getFullYear()+'-'+m+'-'+d.getDate();
                }
            },
            getDate(value){
                if(value!=''&&value!=null&&value!=undefined){
                    let d=new Date(value* 1000);
                    let m=d.getMonth()+1;
                    return d.getFullYear()+'-'+m+'-'+d.getDate();
                }
            },
            getRowKeys(val){
                return val.id+"";
            },
            getStatus(val){
                return this.statusOption.find(v=>v.value==val).label;
            },
            // start policy remark
            contentClick(index,val){
                this.getPolicyRemarkOptionIndex(index);
                this.policyRemarkList[this.currencyPolicyRemarkIndex].content += val;
            },
            getPolicyRemarkOptionIndex(index){
                this.currencyPolicyRemarkIndex = index;
            },
            rePolicyRemarkIndex(){
                this.policyRemarkList.forEach((v,i)=>{
                    v.index=i;
                })
            },
            queryRemarkOption(){
                return queryRemarkOption().then(res=>{
                    if(res.errcode==200){
                        let {data:policyRemarkOption=[]}=res;
                        this.policyRemarkOption=policyRemarkOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryRemarkOption Error");
                });
            },
            // end policy remark
            calTotalPremium(){
                let totalPremium=this.policy.subPremium;
                this.policyRiderList.forEach((v,i)=>{
                    totalPremium +=v.premium;
                })
                this.policy.appPremium = totalPremium;
            },
            // start Rider
            queryProductRiderPeriodOption(val){
                if(val!=''){
                    let params ={productId:val};
                    return queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            this.policyRiderList[this.currencyPolicyRiderIndex].productPeriodOption=productPeriodOption;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryProductRiderPeriodOption Error");
                    });
                }
            },
            queryProductRiderOption(value){
                if(value!=''){
                    let params = {searchName:value,insuranceId:this.policy.insuranceId,productOption:3}
                    return queryProductOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productOption=[]}=res;
                            this.policyRiderList[this.currencyPolicyRiderIndex].productOption=productOption;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryProductRiderOption Error");
                    });
                }
            },
            // end Rider

            // start Customer
            // end Customer
            queryPartnerOption(){
                return queryStaffByStaffType("1,2,3").then(res=>{
                    if(res.errcode==200){
                        let {data:partnerOption=[]}=res;
                        this.partnerOption=partnerOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryPartnerOption Error");
                });
            },
            queryCurrencyOption(){
                return queryCurrencyOption().then(res=>{
                    if(res.errcode==200){
                        let {data:currencyOption=[]}=res;
                        this.currencyOption=currencyOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryCurrencyOption Error");
                });
            },
            queryCustomerOption(val){
                if(val!=''){
                    let params={searchName:val,id:1}
                    return queryCustomerOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:customerOption=[]}=res;
                            this.customerList[this.currentCustomerIndex].customerOption=customerOption;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryCustomerOption Error");
                    });
                }
            },
            queryProductPeriodOption(val){
                if(val!=''){
                    let params ={productId:val};
                    return queryProductPeriodOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productPeriodOption=[]}=res;
                            this.productPeriodOption=productPeriodOption;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryProductPeriodOption Error");
                    });
                }
            },
            queryProductOption(value){
                if(value!=''){
                    let params = {searchName:value,insuranceId:this.policy.insuranceId,productOption:1}
                    return queryProductOption(params).then(res=>{
                        if(res.errcode==200){
                            let {data:productOption=[]}=res;
                            this.productOption=productOption;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("queryProductOption Error");
                    });
                }
            },
            queryInsuranceOption(){
                return queryInsuranceOption().then(res=>{
                    if(res.errcode==200){
                        let {data:insuranceOption=[]}=res;
                        this.insuranceOption=insuranceOption;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("queryInsuranceOption Error");
                });
            },
            initalPolicy(){
                this.policy={
                    id:"",rev:"",policyNo:"",insuranceId:"",productId:"",periodId:"",partnerId:"",trId:"",tr2Id:"",serviceId:"",
                    submitDate:"",payTerm:"",currencyId:"",sumInsured:"",subPremium:"",recPremium:"",appPremium:"",policyDate:"",
                    premiumDate:"",coolingOffDate:"",status:0,policyStatus:1,isComm:0,isAutoPay:0,nextPremiumDate:"",levy:"",
                    nextPremium:"",remark:""
                };
                this.productOption=[];
                this.productPeriodOption=[];
                this.customerList=[];
                this.policyRiderList=[];
                this.policyRemarkList=[];
                this.policyRemarkOption=[];
                this.delPolicyCustList=[];
                this.delPolicyRiderList=[];
                this.delPolicyRemarkList=[];
                this.productList=[];
            },

            handleEdit(row){
                this.activeNames=[];
                this.policyFromVisible=true;
                this.dialogName="修改保單";
                this.initalPolicy();
                this.resetForm("policy");
                return queryPolicyById(row.uuid).then(res=>{
                    if(res.errcode==200){
                        this.policy = Object.assign({},res.data);
                        if(this.policy.submitDate!='' && this.policy.submitDate!=null){
                            this.policy.submitDate = this.policy.submitDate * 1000;
                        }
                        if(this.policy.policyDate!='' && this.policy.policyDate!=null){
                            this.policy.policyDate = this.policy.policyDate * 1000;
                        }
                        if(this.policy.premiumDate!='' && this.policy.premiumDate!=null){
                            this.policy.premiumDate = this.policy.premiumDate * 1000;
                        }
                        if(this.policy.nextPremiumDate!='' && this.policy.nextPremiumDate!=null){
                            this.policy.nextPremiumDate = this.policy.nextPremiumDate * 1000;
                        }
                        if(this.policy.coolingOffDate!='' && this.policy.coolingOffDate!=null){
                            this.policy.coolingOffDate = this.policy.coolingOffDate * 1000;
                        }
                        if(this.policy.issueDate!='' && this.policy.issueDate!=null){
                            this.policy.issueDate = this.policy.issueDate * 1000;
                        }
                        this.productOption = this.policy.productOption;
                        this.productPeriodOption = this.productOption[0].productPeriodList;
                        this.policyRiderList = this.policy.policyRiderList;
                        this.policyRiderList.forEach((v,i)=>{
                            v.productOption.forEach(k=>{
                                v.productPeriodOption =k.productPeriodList;
                            })
                        });

                        //customer
                        this.customerList = this.policy.customerList;
                        this.customerList.forEach((v,i)=>{
                            v.insured = v.insured.toString();
                            v.applicant = v.applicant.toString();
                            v.beneficiary = v.beneficiary.toString();
                            if(v.applicant=='1'){
                                this.ownerName = v.customerOption[0].nameEng + ", " +v.customerOption[0].nameChi
                            }
                        });


                        //remark
                        this.policyRemarkList = this.policy.policyRemarkList;
                        this.policyRemarkList.forEach((v,i)=>{
                            if(v.createDate!='' && v.createDate!=null){
                                v.createDate = v.createDate * 1000;
                            }
                            if(v.deadLine!='' && v.deadLine!=null){
                                v.deadLine = v.deadLine * 1000;
                            }
                            if(v.solvedDate!='' && v.solvedDate!=null){
                                v.solvedDate = v.solvedDate * 1000;
                            }
                        })
                        this.rePolicyRemarkIndex();
                        let item = {nameCn:this.policy.nameCn,nameTw:this.policy.nameTw,nameEng:this.policy.nameEng,periodName:
                            this.policy.productOption[0].productPeriodList.find(v=>v.id==this.policy.periodId).periodName,sumInsured:this.policy.sumInsured,
                            subPremium:this.policy.subPremium,type:"基本計劃"
                        }
                        this.productList.push(item);
                        this.policy.policyRiderList.forEach(v=>{
                            let item2 = {nameCn:v.nameCn,nameTw:v.nameTw,nameEng:v.nameEng,periodName:
                                v.productOption[0].productPeriodList.find(k=>k.id==v.productPeriodId).periodName,sumInsured:v.sumInsured,
                                subPremium:v.premium,type:"附加計劃"
                            }
                            this.productList.push(item2);
                        })

                        this.activities=[];
                        let act1 = {content:'投保',timestamp:this.getDate2(this.policy.submitDate),icon:'fa fa-pencil fa-2x'};
                        this.activities.push(act1);
                        let act2 = {content:'處理中',timestamp:this.getDate2(this.policy.submitDate),icon:'fa fa-spinner fa-2x'};
                        this.activities.push(act2);
                        let act3 = {};
                        if(this.policy.policyRemarkList.length>0){
                            act3 = {content:'跟進事項處理中',timestamp:this.getDate2(this.policy.policyRemarkList[0].createDate),icon:'fa fa-spinner fa-2x'};
                            this.activities.push(act3);
                        }
                        let act4 ={};

                        this.policy.approveDate = this.policy.policyDate;
                        if(this.policy.status == 4){
                            act4 = {content:'保單生效',timestamp:this.getDate2(this.policy.approveDate),
                                type: 'primary',
                                icon: 'fa fa-check-circle-o fa-2x'
                                /*icon: 'el-icon-circle-check-outline'*/};
                            this.activities.push(act4);
                        }
                        let act5 ={};
                        this.policy.laspeDate = this.policy.submitDate;
                        if(this.policy.status == 2){
                            act5 = {content:'終止申請',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act5);
                        }
                        let act6 ={};
                        if(this.policy.status == 5){
                            act6 = {content:'轉出保單',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act6);
                        }

                        let act7 ={};
                        if(this.policy.status == 6){
                            act7 = {content:'保單失效',timestamp:this.getDate2(this.policy.laspeDate),
                                type: 'primary',
                                icon: 'el-icon-circle-close-outline'};
                            this.activities.push(act7);
                        }
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            queryPolicyList(){
                // if(this.count==0){
                //     return '';
                // }
                this.policyTableloading=true;
                var params={page:this.pager.page,size:this.pager.size,searchName:this.searchName,
                    insuranceId:this.searchInsuranceId,status:this.searchStatus,custName:this.searchCustName,
                    partnerId:this.searchPartner,payTerm:this.searchPayTerm,
                    isAutoPay:this.searchIsAutoPay,productName:this.searchProductName,
                    trId:this.searchTrId,tr2Id:this.searchTr2Id,serviceId:this.searchServiceId,
                    staffId:this.$store.getters.staff.id};
                if(this.searchSubmitDate!='' && this.searchSubmitDate!=null){
                    params.submitDate = this.searchSubmitDate/1000;
                }
                return queryMyUserPolicyList(params).then(res=>{
                    if(res.errcode==200){
                        let {size,page,total,data:policyList=[]}=res.data;
                        this.policyList=policyList;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.policyTableloading=false;
                        this.policyList.forEach(v=>{
                            if(v.policyRemarkList.length>0 && v.status!=2){
                                this.expandPolicyRow.push(v.id);
                            }
                        })
                        this.loading=false
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            goApplication(){
                this.$router.push('/mobile/bookingApplication')
            },
            handleCurrentChange(val){
                this.queryPolicyList();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },

            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            },
            loadMore() {
                if(this.listShow==false){

                }else {
                    if(this.pager.total==this.overseaApplicationList.length){
                        setTimeout(()=>{
                            this.loading = false;
                        },3000)
                    }else {
                        this.loading = true;
                        this.pager.size+=3
                        this.queryOverseaApplicationList()
                    }
                }


            },
            handleClose(){

            },
        },
        created() {
        },
        mounted() {
            this.queryOverseaApplicationList();
            const that = this
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight
                    that.fullHeight = window.fullHeight
                })() }
            var curHeight =document.documentElement.clientHeight-this.$refs.header.getBoundingClientRect().bottom
            this.curHeight=curHeight+'px'
            this.queryFileSubTypeOption(1);
            this.queryInsuranceOption();
            this.queryCurrencyOption();
            this.queryOptionMyPolicy();
            this.queryTrOption();
            this.queryTr2Option();
            this.queryServiceOption();
            this.queryRemarkOption();
        },
        activated(){
            this.queryPolicyList();
        },
    }
</script>
<style scoped>
    .dev-line{
        background:url('../../assets/line.png') repeat-x;
        background-position: center;
        background-size: 2px;
    }
    .list_card p:nth-child(1){
        display: inline-block;
        width:30%;
    }
    .list_card p:nth-child(2){
        display: inline-block;
        width:68%;
        text-align: right;

    }
    .first_text{
        font-size:0.39rem;
        font-weight: bold!important;
        padding:6px 0px;
    }
    .list_card{
        padding: 0rem 0.3rem;
        background: #FFFFFF;
        width:93%;
        margin:0.1rem auto;
    }
    .first_text p:nth-child(1){

    }
    .first_text p:nth-child(2){

    }
    .mint-search{
        height:44px!important;
    }
    #content_text div{
        padding:0.15rem 0rem;
    }
    .mint-cell{
        height:33px!important;
    }
    .mint-cell  .mint-cell-wrapper{
        font-size: 0.17rem!important;
        font-weight: bold!important;
    }
</style>



// WEBPACK FOOTER //
// src/views/mobile/mobOverseaApp.vue